import React from 'react';

const ExamSteps = ({ currentStep }) => {
  const steps = [
    {
      id: 1,
      name: 'المعلومات الأساسية',
      description: 'عنوان الاختبار والدرجة والمدة',
      status: currentStep === 1 ? 'current' : currentStep > 1 ? 'complete' : 'incomplete'
    },
    {
      id: 2,
      name: 'الأسئلة',
      description: 'إضافة وتحرير أسئلة الاختبار',
      status: currentStep === 2 ? 'current' : currentStep > 2 ? 'complete' : 'incomplete'
    }
  ];

  return (
    <>
      <style>
        {`
          .exam-stepper-line {
            right: calc(49% + 2.5rem);
            width: 85%;
            top: 1.5rem;
          }
          .exam-stepper-container {
            position: relative;
            z-index: 0;
            padding: 0 3rem;
          }
          .exam-stepper-circle {
            right: calc(50% - 7px);
            border-radius: 9999px;
            height: 3rem;
            width: 3rem;
          }
          .exam-stepper-text {
            margin-top: 1rem;
            margin-right: 35px;
          }
          @keyframes numberFadeIn {
            0% { transform: scale(0); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          .number-animation {
            animation: numberFadeIn 0.3s ease-out forwards;
          }
          .step-incomplete {
            border-color: #9CA3AF;
            background-color: #F3F4F6;
          }
        `}
      </style>
      <nav aria-label="Progress" className="exam-stepper-container">
        <ol role="list" className="flex items-center">
          {steps.map((step, stepIdx) => (
            <li key={step.name} className="relative flex-1">
              <div className="group relative">
                {stepIdx !== steps.length - 1 && (
                  <span 
                    className={`absolute top-4 exam-stepper-line h-0.5 ${
                      step.status === 'complete' ? 'bg-blue-600 dark:bg-blue-500' : 'bg-gray-200 dark:bg-gray-700'
                    }`} 
                    aria-hidden="true" 
                  />
                )}
                
                <div
                  className={`relative z-10 flex h-12 w-12 items-center justify-center exam-stepper-circle ${
                    step.status === 'complete' ? 'border-blue-600 bg-blue-600 dark:border-blue-500 dark:bg-blue-500' :
                    step.status === 'current' ? 'border-blue-600 bg-white dark:border-blue-500 dark:bg-gray-800' :
                    'step-incomplete'
                  } border-2`}
                >
                  {step.status === 'complete' ? (
                    <svg className="h-6 w-6 text-white" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <span className={`${step.status === 'current' ? 'number-animation' : ''}`}>
                      {step.status === 'current' ? (
                        <span className="h-3.5 w-3.5 rounded-full bg-blue-600 dark:bg-blue-500" />
                      ) : (
                        <span className="text-base font-medium text-gray-500">
                          {step.id}
                        </span>
                      )}
                    </span>
                  )}
                </div>

                <div className="exam-stepper-text text-center">
                  <span className="block text-sm font-medium text-gray-900 dark:text-white">
                    {step.name}
                  </span>
                  <span className="mt-1 block text-xs text-gray-500 dark:text-gray-400">
                    {step.description}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default ExamSteps;
